import { Environment } from "./environment.interface";

export const environment: Environment = {
  production: false,
  // Marca del build: hace que la URL del diccionario de Transloco
  // cambie en cada despliegue. Angular hashea los bundles de JS pero
  // NO los assets, asi que sin esto el navegador puede emparejar el JS
  // nuevo con el assets/i18n/<lang>.json viejo de su cache y toda clave
  // nueva sale CRUDA en pantalla. El sha cambia con cada commit y no
  // cambia al re-desplegar el mismo: mismo contenido, misma marca.
  buildId: 'dc3416a01fa354951fc793afd304e1e2660cdafa',
  apiUrl: 'https://polipayintegraciones2-sandbox.polipay.io',
  bankList: 'https://aux-app.polipay.com.mx/bank-codes/',
  apiStp: 'https://polipayintegraciones2-sandbox.polipay.io/api_stp/',
  uploadLogoUrl: 'https://e190jd3j4f.execute-api.us-east-2.amazonaws.com/v1/subir-imagen',
  getLogoImg: 'https://e190jd3j4f.execute-api.us-east-2.amazonaws.com/v1/foto-perfil',
  xApiKey: 'QuKbJtEnhtOtsU0DRFNe7sA4TYvKT2yUXKUVEfIZuyo',
  keyInfoUser: 'PXX679QHrvyprJurHGuTXtIetRZWQ2Hg',
  testTpvUrl: 'http://3.131.110.125:8080',
  FRONT_PRIVATE_KEY_B64: 'pCKiiQ6GY16OQ2EIcpD2yGEjOVnFDlHf0Et1iGGmURA=',
  BACK_PUBLIC_KEY_B64: 'brdJ+hYldI15Zc6RtkXoxKV4XIL9BUT+e7LtA2couzo=',
  API_KEY: 'JTQXDWmOq9TlLI8rgLqXDHFL89AIaehy',
  graphqlApiUrl: 'https://tpv-uat.polipay.io',
  storesApiUrl: 'http://18.225.5.223:8080/api',
  clientApiUrl: 'http://3.131.110.125:8080/api',
  notificationUrl: 'https://serial-focus-routes-ross.trycloudflare.com',
  tpvApiUrl: '',
  tpvRestApi: true,
  tpvUseMocks: false,
  paymentsDashboardUseMocks: false,
  tpvCreationEnabled: true,
  countryUseMocks: false,
  maintenanceMode: false,
  storesAccountId: '',
  businessDataApiUrl: '',
  termsAndConditionsUrl: '',
  tenantThemeEnabled: false,
  tenantId: undefined,
  tenantCdnUrl: 'https://d3sl364cd72vmz.cloudfront.net',
  tenantDomainSuffix: '',
  tenantQaOverrideEnabled: true,
  featureFlags: {"entities":true,"dashboard":true,"transactions":true,"cards":true,"ecommerce":true,"referencePayments":false,"tpv":true,"tpvSubmodules":true,"cardsSubmodules":false, qrWallet: true, qrWalletSubmodules: true},
};
